/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireReportListItemModel } from '../../models/questionnaire-report-list-item-model';

export interface ApiConsumerQuestionnaireReportsGet$Params {
}

export function apiConsumerQuestionnaireReportsGet(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireReportsGet$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<Array<QuestionnaireReportListItemModel>>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireReportsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<Array<QuestionnaireReportListItemModel>>;
    })
  );
}

apiConsumerQuestionnaireReportsGet.PATH = '/api/consumer/questionnaire/reports';
